import * as React from 'react';
import { observer } from 'mobx-react';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { ZuluIcon } from 'src/app/shared/icon';

interface PlaceEditorViewProps {
	placeRequest: DropdownRequest<PlaceSummary>;
	value: number | number[] | null;
	mode: ControlMode;
	onChanged: (number: PlaceSummary | PlaceSummary[]) => void;
	label?: string;
	multi?: boolean;
	required?: boolean;
	regionId?: number;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class PlaceEditorView extends React.Component<PlaceEditorViewProps, {}> {
	constructor(props: Readonly<PlaceEditorViewProps>) {
		super(props);
	}

	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Place';
		}
		return (
			<DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				multi={this.props.multi}
				model={this.props.value}
				required={this.props.required}
				disabled={this.props.mode == 'display'}
				onChanged={this.props.onChanged}
				request={this.props.placeRequest}
				keyField="id"
				textField="displayName"
				optionRenderer={(item: PlaceSummary) => {
					switch (item.type) {
						case 0:
							return (
								<React.Fragment>
									<ZuluIcon type="environment" className="pr-1" />
									{item.displayName}
								</React.Fragment>
							);
						case 1:
							return (
								<React.Fragment>
									<ZuluIcon type="icon-plane" className="pr-1" />
									{item.displayName}
								</React.Fragment>
							);
						case 2:
							return (
								<React.Fragment>
									<ZuluIcon type="icon-hotel" className="pr-1" />
									{item.displayName}
								</React.Fragment>
							);
						case 3:
							return (
								<React.Fragment>
									<ZuluIcon type="icon-train" className="pr-1" />
									{item.displayName}
								</React.Fragment>
							);
						case 4:
							return (
								<React.Fragment>
									<ZuluIcon type="car" className="pr-1" />
									{item.displayName}
								</React.Fragment>
							);
					}
				}}
				cascadeValue={this.props.regionId}
				cascadeField="regionId"
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/places/parts/place-editor.view.tsx